


















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IndexBar, IndexAnchor, Cell, Search } from "vant";
import * as _ from "lodash";
import dataShare from "@/views/mall/dataShare";
import UserService from "@/service/UserService";
import { RoleInfoEntity } from "../../../model/system";
import btripServcice from "../../../service/btripServcice";
import { ServiceType } from "../../../model/Base";
import { BtripTextEntity } from "../../../model/Btrip";

@Component({
  name: "chooseTripIntent",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [Search.name]: Search,
  },
})
export default class extends Vue {
  keywords = "";

  dataShare = dataShare;

  ProjectDatas: any = [];
  // searchLists: any[] = [];
  isSearch = false;

  get options() {
    return this.dataShare.projectCodes;
  }

  get OwnerID() {
    return this.$route.query.OwnerID;
  }
  get approvalCode() {
    return this.$route.query.approvalCode;
  }

  mounted() {}
  select(value: any) {
    // console.log(`keywords ${value}`);
    if (!value.ProjectID) {
      value = {
        ProjectCode: value,
        ProjectID: "",
      };
    }
    this.dataShare.projectCode = value;
    this.back();
  }

  get filterOptions() {
    let __self = this;
    // __self.searchLists = [];
    if (this.keywords != "") {
      let searchList = _.filter(__self.options, (o: any) => o.ProjectCode.indexOf(this.keywords) > -1);
      // let result = _.find(__self.options, (o: any) => o.ProjectCode == this.keywords);
      return _.uniq(searchList);
    }
    return __self.options;
  }

  back() {
    history.back();
  }
}
